import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ChangePasswordRequest = {
  body: ChangePasswordRequestBody;
};

type ChangePasswordRequestBody = {
  user: {
    current_password: string;
    password: string;
  };
};

export const changePassword = async ({ body }: ChangePasswordRequest) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.user.updatePassword, body);
